var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loggedIn)?_c('div',{staticClass:"profile"},[_c('div',{staticClass:"user"},[_vm._v(" "+_vm._s(_vm.session.email)+" ")]),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_vm._v(" Log Out ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }